/**
 * Generated bundle index. Do not edit.
 */

export {EventsService,TableSearcherService,TableSearcherInterface,TableSearcherTypesEnum,AngularTableSearcherModule} from './public_api';

export {TableSearcherComponent as ɵa} from './src/app/table-searcher/table-searcher.component';